import React, { useContext, Fragment } from 'react';
import Routing from './Routing.js';
import { Dialog, DialogContent, Typography, Grid, CircularProgress } from '@material-ui/core';
import { AuthContext } from '../contexts/AuthContext.js';
import { useTranslation } from 'react-i18next';

const Loading = <Grid container justify='center'
		      alignItems='center'
		      style={{height: '100vh', background: '#1ce3b6'}}>
		  <CircularProgress color='primary'/>
		</Grid>;

const Translating = () => {
  return (
    <Dialog open>
      <DialogContent>
	<Typography variant='subtitle1'> Translating... </Typography>
      </DialogContent>
    </Dialog>
  );
};

const AppViews = () => {
  const { ready } = useTranslation();
  return (
    <Fragment>
      { !ready && <Translating/> }
      <Routing/>
    </Fragment>
  );
};

export default () => {
  const { checkingAuth } = useContext(AuthContext);
  return checkingAuth ? Loading : <AppViews/>;
};
